import PropTypes from 'prop-types';

export default PropTypes.oneOfType([PropTypes.object, PropTypes.shape({
  x: PropTypes.object,
  y: PropTypes.object
})]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/Helpers/fixedToShape.js
// module id = 64
// module chunks = 0